module.exports = "https://static.wmbcdn.com/uniweb/images/51d7f74e062559645817b5eb32b28de0.html";